import React from 'react'
import * as loading from '../../../assets/json/loading-success.json'
import { LottieWrapper } from '../../common/LottieWrapper'

export const LoadingSuccess = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className="">
      <LottieWrapper options={defaultOptions} height={200} width={200} />
    </div>
  )
}
